const { default: axiosIns } = require('@/libs/axios')

const ErrorDashboardService = {
  // GET - ErrorDashboardApi
  async getErrors() {
    return axiosIns.get('admin/error/dashboard').then(response => response.data)
  },
  async getErrorsWithDateRange(dateRange) {
    return axiosIns.get(`admin/error/dashboard/errors?dateRange=${dateRange}`).then(response => response.data)
  },
  async exportCsv(dateRange) {
    return axiosIns.get(`admin/error/dashboard/export/csv?dateRange=${dateRange}`, { responseType: 'blob' }).then(response => response.data)
  },
  async exportExcel(dateRange) {
    return axiosIns.get(`admin/error/dashboard/export/excel?dateRange=${dateRange}`, { responseType: 'blob' }).then(response => response.data)
  },
}
export default ErrorDashboardService
